import React, { useRef } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { ArrowBackRounded, ChevronRightRounded, Diversity3Rounded } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import Footer from "../components/Landing/Footer";
import AgingParentProductTour from "../components/HowItWorks/AgingParentProductTour";
import HowToVideos from "../components/HowItWorks/HowToVideos";
import "../components/InteractiveDemo/interactiveDemo.css";

const HowItWorksPage = () => {
  const tourRef = useRef(null);
  const startTour = () => tourRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <Box className="interactive-demo-page how-it-works-tour-page" data-cy="how-it-works-page">
      <Container maxWidth="lg" sx={{ px: { xs: 2.25, md: 4 } }}>
        <Box component="header" sx={{ minHeight: { xs: 620, md: 700 }, py: { xs: 7, md: 10 }, display: "grid", gridTemplateColumns: { xs: "1fr", md: "minmax(0, 1.05fr) minmax(340px, 0.95fr)" }, alignItems: "center", gap: { xs: 5, md: 8 } }}>
          <Box>
            <Typography className="demo-kicker">How it works · Videos and interactive story</Typography>
            <Typography component="h1" sx={{ mt: 2, maxWidth: 680, fontFamily: "'Fraunces', Georgia, serif", fontSize: { xs: "3rem", sm: "3.8rem", md: "4.7rem" }, fontWeight: 600, lineHeight: 0.98, letterSpacing: "-0.05em", color: "#24342F" }}>
              A little easier to care together.
            </Typography>
            <Typography sx={{ mt: 2.5, maxWidth: 620, color: "#687972", fontSize: { xs: "1rem", md: "1.15rem" }, lineHeight: 1.7 }}>
              Watch how to capture updates and find answers in your care history. Or follow Elena and Marcus as they share care for their father, Robert.
            </Typography>
            <Box sx={{ mt: 3.5, display: "flex", flexDirection: { xs: "column", sm: "row" }, flexWrap: "wrap", gap: 1.25 }}>
              <Button href="#how-to-videos" variant="contained" endIcon={<ChevronRightRounded />} sx={primaryButtonSx}>Watch the how-to videos</Button>
              <Button onClick={startTour} variant="outlined" sx={secondaryButtonSx}>Try Robert&apos;s story</Button>
              <Button component={RouterLink} to="/" variant="outlined" startIcon={<ArrowBackRounded />} sx={secondaryButtonSx}>Back to home</Button>
            </Box>
            <Typography sx={{ mt: 1.5, color: "#89958F", fontSize: "0.78rem" }}>Robert&apos;s story: about two minutes · Fictional family and care details</Typography>
          </Box>

          <Box className="tour-preview-card">
            <div className="tour-preview-person"><span>R</span><div><small>Shared care story for</small><strong>Robert</strong></div></div>
            <div className="tour-preview-update elena"><span>E</span><div><small>Elena · 9:10 AM</small><p>Dad felt dizzy after breakfast. Water and rest helped.</p></div></div>
            <div className="tour-preview-connector"><Diversity3Rounded /><span>Shared with Robert&apos;s care circle</span></div>
            <div className="tour-preview-update marcus"><span>M</span><div><small>Marcus · 4:35 PM</small><p>Dad felt steady this afternoon. Set up water and breakfast for tomorrow.</p></div></div>
          </Box>
        </Box>
      </Container>

      <HowToVideos />
      <AgingParentProductTour ref={tourRef} />
      <Footer variant="desktop" />
    </Box>
  );
};

const primaryButtonSx = { minHeight: 50, px: 2.8, borderRadius: "14px", bgcolor: "#477765", color: "#fff", textTransform: "none", fontWeight: 700, boxShadow: "0 14px 30px rgba(71,119,101,0.2)", "&:hover": { bgcolor: "#3E6C5B", boxShadow: "0 16px 34px rgba(71,119,101,0.26)" } };
const secondaryButtonSx = { minHeight: 50, px: 2.8, borderRadius: "14px", borderColor: "#B8C9C1", color: "#477765", bgcolor: "rgba(255,255,255,0.7)", textTransform: "none", fontWeight: 700 };

export default HowItWorksPage;
